// extracted by mini-css-extract-plugin
module.exports = {"Shops":"WIKhr"};